import gql from 'graphql-tag'
import { WeldPartsFragment } from '../Welds/mutations'

export const WeldingLogDataFetchQuery = gql`
  query WeldingLogFetchQuery {
    welding_log_data_types {
      id
      name
    }
    welding_consumables {
      id
      name
    }
  }
`

export const WpsByWeldQuery = gql`
  query WpsByWeldQuery($weld_id: Int) {
    wps_by_weld(weld_id: $weld_id) {
      id
      no
    }
  }
`

export const WeldingLogAllWeldersFetchQuery = gql`
  query WeldingLogAllWeldersQuery($filters: PeopleFilterInput) {
    people(filters: $filters) {
      list {
        id 
        name
      }
    }
  }
`

export const InspectionLogDataFetchQuery = gql`
  query InspectionLogFetchQuery($filters: PeopleFilterInput) {
    inspection_log_data_types {
      id
      name
    }
    people(filters: $filters) {
      list {
        id 
        name
      }
    }
  }
`

export const createOrUpdateLogMutation = gql`
  mutation createOrUpdateLogs(
    $id: ID, 
    $type: String!, 
    $person_id: ID, 
    $welds_id: [Int]!,
    $welding_consumables: [String],
    $wps_ids: [Int],
    $inspection_category_type_id: ID, 
    $weld_failed: Int, 
    $double_length: Boolean,
    $gauging: Boolean,
    $hold_time_bypassed: Boolean,
    $skipped: Boolean,
    $complete: Int, 
    $complete_percent: String,
    $note: String, 
    $date: String, 
    $log_data: String
   ) {
    createOrUpdateLogs(
      id: $id, 
      type: $type, 
      person_id: $person_id, 
      welds_id: $welds_id,
      welding_consumables: $welding_consumables,
      wps_ids: $wps_ids,
      inspection_category_type_id: $inspection_category_type_id, 
      weld_failed: $weld_failed, 
      double_length: $double_length,
      gauging: $gauging,
      hold_time_bypassed: $hold_time_bypassed,
      skipped: $skipped,
      complete: $complete, 
      complete_percent: $complete_percent,
      note: $note, 
      date: $date, 
      log_data: $log_data
    ) {
      logs {
        id
        errors
        type
        person {
          id
          uuid
          first_name
          last_name
        }
        welding_consumables {
          id
          name
        }
        wps_ids
        wps {
          id
          no
        }
        inspection_category_type {
          id
          name
        }
        weld_failed
        double_length
        gauging
        hold_time_bypassed
        complete
        complete_percent
        note
        date
        log_data
        created_at
        updated_at
        weld {
          ...WeldParts
        }
      }
    }
  }
${WeldPartsFragment}
`

export const destroyLogMutation = gql`
  mutation destroyLogs($id: ID!) {
    destroyLogs(id: $id) {
      response
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/EventLog/mutations.js